<template>
  <div v-if="!calldata[0].protocol">
    <h4>
      Look like you don't have confingured Air Controller Sensor. Here's
      Instruction
    </h4>
    <br /><br />
    <h5>
      <ul style="padding-left: 1%">
        <li>1: Connect WiFi via Device Wifi Manager.</li>
        <br />
        <ul style="padding-left: 1%">
          <li>1.1: Connect device WiFi and it will lead to WiFi Manager.</li>
          <br />
          <li>1.2: Select WiFi you want to connect and enter password.</li>
          <br />
        </ul>
        <li>
          2: Read remote protocol by point remote to device and press any button
          on remote
        </li>
        <br />
        <li>3: Refresh this page.</li>
      </ul>
    </h5>
  </div>
  <div v-else-if="inactive">test</div>
  <div v-else>
    <!-- <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="5" vs-xs="12">
    <vs-card style="background: #147efb; border-radius: 20px;">

      <vs-row >
        <h4> <vs-icon icon="power_settings_new" size="50px" color="#ffffff"></vs-icon></h4><vs-spacer />
        
       <h3 style="color: #ffffff;"> <b>ON</b></h3>
        </vs-row> 
        <br>
        <vs-row style="color: #ffffff; display: flex; align-items: center;"><h4>Power</h4>
      
        </vs-row>

    </vs-card>
  </vs-col>
  <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="5" vs-xs="12">
    <vs-card>kglhnk</vs-card>
  </vs-col>
</vs-row> -->

    <div v-if="switch1 == 1">
      <vs-row class="ml-3 mb-4">
        <h3 class="headerText">Air Controller : {{ this.sensorid }}</h3>
        <br />
      </vs-row>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="space-around"
          vs-w="12"
        >
          <!-- Temp 1 -->
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="color: #ffffff"
            ><vs-card style="border-radius: 10px; background: #147efb">
              <vs-row>
                <h4>
                  <vs-icon
                    icon="power_settings_new"
                    size="30px"
                    color="#ffffff"
                  ></vs-icon
                  >&nbsp;Power
                </h4>
                <vs-spacer />
                <vs-switch v-model="switch1" @click="send('Off', 0, 0, 0)">
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>
              </vs-row>
            </vs-card>
            <!-- Mode 2 -->
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="color: #111111"
              ><vs-card style="border-radius: 10px">
                <vs-row style="color: #147efb">
                  <h4 v-if="airmode == 'Off'">
                    <vs-icon
                      icon="power_settings_new"
                      size="30px"
                      color="#FF5668"
                    ></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <h4 v-if="airmode == 'Auto'">
                    <vs-icon
                      icon="autorenew"
                      size="30px"
                      color="#147efb"
                    ></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <h4 v-if="airmode == 'Cool'">
                    <vs-icon
                      icon="ac_unit"
                      size="30px"
                      color="#147efb"
                    ></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <h4 v-if="airmode == 'Heat'">
                    <vs-icon
                      icon="whatshot"
                      size="30px"
                      color="#147efb"
                    ></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <h4 v-if="airmode == 'Dry'">
                    <vs-icon icon="eco" size="30px" color="#147efb"></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <h4 v-if="airmode == 'Fan'">
                    <vs-icon icon="toys" size="30px" color="#147efb"></vs-icon>
                    &nbsp;<b>Mode</b>
                  </h4>
                  <vs-spacer />
                  <h3 class="headerText">
                    <b>{{ airmode }}</b>
                  </h3> </vs-row
                ><br />
                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Off'"
                      radius
                      color="danger"
                      type="flat"
                      @click="send(0, 0, 'Off', 0)"
                      icon="power_settings_new"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Off'"
                      radius
                      color="danger"
                      type="filled"
                      @click="send(0, 0, 'Off', 0)"
                      icon="power_settings_new"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Auto'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 'Auto', 0)"
                      icon="autorenew"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Auto'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 'Auto', 0)"
                      icon="autorenew"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Cool'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 'Cool', 0)"
                      icon="ac_unit"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Cool'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 'Cool', 0)"
                      icon="ac_unit"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Heat'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 'Heat', 0)"
                      icon="whatshot"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Heat'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 'Heat', 0)"
                      icon="whatshot"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Dry'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 'Dry', 0)"
                      icon="eco"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Dry'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 'Dry', 0)"
                      icon="eco"
                    ></vs-button>
                  </vs-col>

                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="airmode != 'Fan'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 'Fan', 0)"
                      icon="toys"
                    ></vs-button>
                    <vs-button
                      v-if="airmode == 'Fan'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 'Fan', 0)"
                      icon="toys"
                    ></vs-button>
                  </vs-col>
                </vs-row>

                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-col
                    :key="index"
                    v-for="(item, index) in options2"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    {{ item }}
                  </vs-col>
                </vs-row>
              </vs-card>
            </vs-col>
            <!-- Fan 3 -->
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="color: #111111"
              ><vs-card style="border-radius: 10px">
                <vs-row>
                  <h4 style="color: #147efb">
                    <vs-icon icon="toys" size="30px"></vs-icon>&nbsp;<b
                      >Fan Level</b
                    >
                  </h4>
                  <vs-spacer />
                  <h3 v-if="fan == 'Min'" class="headerText"><b>Min</b></h3>
                  <h3 v-if="fan == 'Low'" class="headerText"><b>Low</b></h3>
                  <h3 v-if="fan == 'Medium'" class="headerText">
                    <b>Medium</b>
                  </h3>
                  <h3 v-if="fan == 'High'" class="headerText"><b>High</b></h3>
                  <h3 v-if="fan == 'Max'" class="headerText">
                    <b>Max</b>
                  </h3> </vs-row
                ><br />
                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'Auto'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'Auto')"
                      id="btn1"
                      icon="autorenew"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'Auto'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'Auto')"
                      id="btn1"
                      icon="autorenew"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'Min'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'Min')"
                      id="btn1"
                      icon="looks_one"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'Min'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'Min')"
                      id="btn1"
                      icon="looks_one"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'Low'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'Low')"
                      id="btn1"
                      icon="looks_two"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'Low'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'Low')"
                      id="btn1"
                      icon="looks_two"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'Medium'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'Medium')"
                      id="btn1"
                      icon="looks_3"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'Medium'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'Medium')"
                      id="btn1"
                      icon="looks_3"
                    ></vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'High'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'High')"
                      id="btn1"
                      icon="looks_4"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'High'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'High')"
                      id="btn1"
                      icon="looks_4"
                    ></vs-button>
                  </vs-col>

                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-button
                      v-if="fan != 'Max'"
                      radius
                      color="#147efb"
                      type="flat"
                      @click="send(0, 0, 0, 'Max')"
                      id="btn1"
                      icon="looks_5"
                    ></vs-button>
                    <vs-button
                      v-if="fan == 'Max'"
                      radius
                      color="#147efb"
                      type="filled"
                      @click="send(0, 0, 0, 'Max')"
                      id="btn1"
                      icon="looks_5"
                    ></vs-button>
                  </vs-col>
                </vs-row>

                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-col
                    :key="index"
                    v-for="(item, index) in options1"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="2"
                  >
                    {{ item }}
                  </vs-col>
                </vs-row>
              </vs-card>
            </vs-col>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="space-around"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card style="border-radius: 20px">
              <vs-row>
                <h4 style="color: #147efb">
                  <vs-icon icon="flare" size="30px"></vs-icon>&nbsp;<b
                    >Temperature</b
                  >
                </h4>
              </vs-row>
              <br />
              <vs-row style="display: flex; align-items: center"
                ><br />
                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <round-slider
                    v-model="temp2"
                    max="35"
                    min="16"
                    start-angle="315"
                    end-angle="+270"
                    line-cap="round"
                    radius="120"
                    :valueChange="tempchange(temp2)"
                  />
                </vs-row>
                <vs-row
                  vs-align="center"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-button
                    radius
                    color="#147efb"
                    @click="temp2 -= 1.0"
                    type="filled"
                    :disabled="temp2 <= 16"
                  >
                    <span>
                      <vs-icon
                        icon="remove"
                        size="27px"
                        color="#ffff"
                      ></vs-icon>
                    </span>
                  </vs-button>
                  <h4 style="color: #111111">{{ temp2 }} <b>℃</b></h4>

                  <vs-button
                    radius
                    color="#147efb"
                    @click="temp2 += 1.0"
                    type="filled"
                    :disabled="temp2 >= 35"
                  >
                    <span>
                      <vs-icon icon="add" size="27px" color="#ffff"></vs-icon>
                    </span>
                  </vs-button>
                </vs-row>
              </vs-row> </vs-card></vs-col
        ></vs-row>
      </vs-col>
    </div>

    <!-- <vs-row vs-type="flex" v-if="switch1==1">
  
  <vs-col    vs-lg="7" vs-sm="7" vs-xs="12">
    
    <h2>&nbsp;&nbsp;Air Controller : {{this.sensorid}}</h2><br>

     <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
 
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-card style="background: #147efb; border-radius: 20px;">

      <vs-row >
        <h4> <vs-icon icon="power_settings_new" size="50px" color="#ffffff"></vs-icon></h4><vs-spacer />
        
       <h3 style="color: #ffffff;"> <b>ON</b></h3>
        </vs-row> 
        <br>
        <vs-row style="color: #ffffff; display: flex; align-items: center;"><h4>Power</h4>
      
        </vs-row>

    </vs-card>
  </vs-col>
   <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-card style="border-radius: 20px;">
      <vs-row >
        <h4> <vs-icon icon="flare" size="50px" color="#147efb"></vs-icon></h4><vs-spacer />
        
       <h3 style="color: #111111;">{{temp2}} <b>℃</b></h3>
        </vs-row> 
        <br>
        <vs-row style="display: flex; align-items: center;"><h4>Temperature</h4>
      
        </vs-row>
      
    </vs-card>
  </vs-col>
</vs-row>
 <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
 
   <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-card style="border-radius: 20px;">
      <vs-row v-if="fan==0">
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
      <vs-spacer />
      <h3 v-if="fan==0" style="color: #111111;"> <b>Min</b></h3>
           </vs-row>
      <vs-row v-if="fan==25" >
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
       <vs-spacer />
      <h3 v-if="fan==25" style="color: #111111;"> <b>Low</b></h3>
           </vs-row>
      <vs-row v-if="fan==50">
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
      <vs-spacer />
      <h3 v-if="fan==50" style="color: #111111;"> <b>Medium</b></h3>
           </vs-row>
      <vs-row v-if="fan==75">
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="panorama_fish_eye" size="25px" color="#347efb"></vs-icon></h4>
      <vs-spacer />
      <h3 v-if="fan==75" style="color: #111111;"> <b>High</b></h3>
           </vs-row>
      <vs-row v-if="fan==100">
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <h4> <vs-icon icon="lens" size="25px" color="#347efb"></vs-icon></h4>
        <vs-spacer />
        <h3 v-if="fan==0" style="color: #111111;"> <b>Min</b></h3>
         <h3 v-if="fan==25" style="color: #111111;"> <b>Low</b></h3>
          <h3  v-if="fan==50" style="color: #111111;"> <b>Medium</b></h3>
           <h3 v-if="fan==75" style="color: #111111;"> <b>High</b></h3>
            <h3 v-if="fan==100" style="color: #111111;"> <b>Max</b></h3></vs-row>
        <br><br>
        <vs-row style="color: #111111; "><h4>Fan Level</h4>
        </vs-row>
        
        
    </vs-card>
  </vs-col>
   <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-card style="border-radius: 20px;">
      <vs-row >
         <h4 v-if="airmode=='Off'"> <vs-icon icon="power_settings_new" size="45px" color="#FF5668"></vs-icon></h4>
        <h4 v-if="airmode=='Auto'"> <vs-icon icon="autorenew" size="45px" color="#147efb"></vs-icon></h4>
        <h4 v-if="airmode=='Cool'"> <vs-icon icon="ac_unit" size="45px" color="#147efb"></vs-icon></h4>
        <h4 v-if="airmode=='Heat'"> <vs-icon icon="whatshot" size="45px" color="#147efb"></vs-icon></h4>
        <h4 v-if="airmode=='Dry'"> <vs-icon icon="eco" size="45px" color="#147efb"></vs-icon></h4>
        <h4 v-if="airmode=='Fan'"> <vs-icon icon="toys" size="45px" color="#147efb"></vs-icon></h4><vs-spacer />
        
        
       <h3 style="color: #111111;"><b>{{airmode}}</b> </h3>
        </vs-row> 
        <br>
        <vs-row style="display: flex; align-items: center;"><h4>Mode</h4>
      
        </vs-row>
     
    </vs-card>
  </vs-col>
</vs-row>
    
 
  </vs-col>
  <vs-col vs-type="flex" vs-justify="center"  vs-lg="5" vs-sm="5" vs-xs="12" >
    <vs-card style=" border-radius: 20px;  ">
     
      
      <vs-col style="color:#ffffff;" ><vs-card   style=" border-radius: 10px; background: #147efb;">
        <vs-row>
        <h4> <vs-icon icon="power_settings_new" size="30px" color="#ffffff"></vs-icon>&nbsp;Power</h4>
        <vs-spacer />
      
        <vs-switch v-model="switch1" >
              <span slot="on">On</span>
              <span slot="off">Off</span>
            </vs-switch>
       
        </vs-row>

      </vs-card>
      
      </vs-col>
     
      <vs-col v-if="switch1==1" ><vs-card  style=" border-radius: 10px;">
        <vs-row>
         
        <h4 style="color:#147efb;"> <vs-icon icon="nights_stay" size="30px"  ></vs-icon>&nbsp;<b>Mode</b></h4>
        <vs-spacer />
        
       
        </vs-row><br>
       <vs-row vs-align="center" vs-type="flex"  vs-justify="space-around" vs-w="12">
         
          <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
           <vs-button radius color="danger" type="flat" @click="send(0,0,'Off',0)"   icon="power_settings_new"></vs-button>
           </vs-col>
            <vs-col  vs-type="flex" vs-justify="center"  vs-align="center" vs-w="2">
   
   
           <vs-button radius color="#147efb" type="flat"  @click="send(0,0,'Auto',0)"  icon="autorenew"></vs-button>
           </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
   
   
           <vs-button radius color="#147efb" type="flat" @click="send(0,0,'Cool',0)" icon="ac_unit"></vs-button>
           </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
   
   
           <vs-button radius color="#147efb" type="flat"  @click="send(0,0,'Heat',0)"  icon="whatshot"></vs-button>
           </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
   
   
           <vs-button radius color="#147efb" type="flat"  @click="send(0,0,'Dry',0)" icon="eco"></vs-button>
           </vs-col>

            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
   
   
           <vs-button radius color="#147efb" type="flat"  @click="send(0,0,'Fan',0)" icon="toys"></vs-button>
           </vs-col>
 
 
</vs-row>

 <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
 
  <vs-col :key="index" v-for="(item,index) in options2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
    
        
    {{item}}
  </vs-col>
</vs-row><br>

 <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
 
  <round-slider
  v-model="temp2"
  max="35"
  min="16"
  start-angle="315"
  end-angle="+270"
  line-cap="round"
  radius="120"
/>
</vs-row>
<vs-row style="color:#43288C;">
         
        <h4>&nbsp;Temperature</h4>
        <vs-spacer />
        <h4>{{temp2}}<b>℃</b></h4>
       
        </vs-row><br>
 <vs-row style="color:#43288C;">
         
        <h4 >&nbsp;Fan Level</h4>
        <vs-spacer />
        <h4 v-if="fan==0">Min</h4>
        <h4 v-if="fan==25">Low</h4>
        <h4 v-if="fan==50">Medium</h4>
        <h4 v-if="fan==75">High</h4>
        <h4 v-if="fan==100">Max</h4>
       
        </vs-row><br>
      <vs-row vs-align="center" vs-type="flex" vs-justify="space-around" vs-w="12">
       <div width = "50%" ><vs-slider   color="#FF5668"  ticks step=25 v-model="fan"/></div>
      </vs-row>

      
      </vs-card></vs-col><br>
     
      
     



     

    </vs-card>
  </vs-col>
 
</vs-row> -->

    <vs-row vs-w="12">
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
        <div style="border-radius: 20px" v-if="switch1 == 0">
          <vs-row vs-w="12">
            <vs-row class="ml-3 mb-4">
              <h2>Air Controller : {{ this.sensorid }}</h2>
              <br />
            </vs-row>
            <vs-row
              vs-align="center"
              vs-type="flex"
              vs-justify="space-around"
              vs-w="12"
            >
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="background: #ff6c3b; border-radius: 20px">
                  <vs-row>
                    <h1>
                      <vs-icon
                        icon="power_settings_new"
                        size="50px"
                        color="#ffffff"
                      ></vs-icon>
                    </h1>
                    <vs-spacer />

                    <h2 style="color: #ffffff"><b>OFF</b></h2>
                  </vs-row>
                  <br />
                  <br />
                  <vs-row
                    style="color: #ffffff; display: flex; align-items: center"
                    ><h4>Power</h4>
                    <vs-spacer />

                    <vs-switch v-model="switch1" @click="send('On', 0, 0, 0)">
                      <span slot="on">On</span>
                      <span slot="off">Off</span>
                    </vs-switch>
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 20px">
                  <vs-row style="display: flex; align-items: center">
                    <h1>
                      <vs-icon
                        icon="flare"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <vs-spacer />
                    <h4 style="color: #111111">Temperature</h4>
                  </vs-row>
                  <br />
                  <h2 style="color: #111111">{{ temp2 }} <b>℃</b></h2>
                </vs-card>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 20px">
                  <vs-row style="display: flex; align-items: center">
                    <h1>
                      <vs-icon
                        icon="rss_feed"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <vs-spacer />
                    <h4 style="color: #111111">Fan Level</h4>
                  </vs-row>
                  <br />

                  <vs-row style="display: flex; align-items: center">
                    <h2 v-if="fan == 'Min'" style="color: #111111">
                      <b>Min</b>
                    </h2>
                    <h2 v-if="fan == 'Low'" style="color: #111111">
                      <b>Low</b>
                    </h2>
                    <h2 v-if="fan == 'Medium'" style="color: #111111">
                      <b>Medium</b>
                    </h2>
                    <h2 v-if="fan == 'High'" style="color: #111111">
                      <b>High</b>
                    </h2>
                    <h2 v-if="fan == 'Max'" style="color: #111111">
                      <b>Max</b>
                    </h2>
                    <h2 v-if="fan == 'Auto'" style="color: #111111">
                      <b>Auto</b>
                    </h2>
                    <vs-spacer />
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="3"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 20px">
                  <vs-row style="display: flex; align-items: center">
                    <h1 v-if="airmode2 == 'Off'">
                      <vs-icon
                        icon="power_settings_new"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <h1 v-if="airmode2 == 'Auto'">
                      <vs-icon
                        icon="autorenew"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <h1 v-if="airmode2 == 'Cool'">
                      <vs-icon
                        icon="ac_unit"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <h1 v-if="airmode2 == 'Heat'">
                      <vs-icon
                        icon="whatshot"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <h1 v-if="airmode2 == 'Dry'">
                      <vs-icon icon="eco" size="50px" color="#FF6C3B"></vs-icon>
                    </h1>
                    <h1 v-if="airmode2 == 'Fan'">
                      <vs-icon
                        icon="toys"
                        size="50px"
                        color="#FF6C3B"
                      ></vs-icon>
                    </h1>
                    <vs-spacer />
                    <h4 style="color: #111111">Mode</h4>
                  </vs-row>
                  <br />
                  <h2 style="color: #111111">
                    <b>{{ airmode2 }}</b>
                  </h2>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import RoundSlider from "vue-round-slider";

export default {
  name: "Aircon",
  components: {
    RoundSlider,
  },
  props: ["calldata", "sensorid", "type"],

  data: () => ({
    inactive: false,
    this1: "",
    fan: "",
    temp: 0,
    switchMode: true,
    value2: 25,
    switchFan: true,
    switchTemp: true,
    switch1: true,
    temp2: 0,
    val7: 10,
    fan2: "",
    mode2: "",
    power2: "",
    options1: ["Auto", "Min", "Low", "Medium", "High", "Max"],
    options2: ["Off", "Auto", "Cool", "Heat", "Dry", "Fan"],
    options3: ["Off", "Auto", "Cool", "Heat", "Dry", "Fan"],
    airmode: "",
    power: "",
    bool: false,
    checker: false,
  }),
  methods: {
    tempchange(value) {
      this.checker = true;
      this.temp = value;
      setTimeout(() => {
        if (this.checker) {
          this.send(0, this.temp, 0, 0);
        }
      }, 1000);
    },
    send(bool, temp, mode, fan, this1) {
      if (fan) this.fan = fan;
      if (mode) this.airmode = mode;
      if (temp) this.temp = temp;
      if (bool) this.power = bool;
      this.$vs.loading();
      this.$API
        .post("updatestate/" + this.sensorid, {
          Protocol: this.calldata[0].protocol,
          Power: this.power,
          Mode: this.airmode,
          Temp: this.temp,
          Fan: this.fan,
          state: true,
        })
        .then(() => {
          this.checker = false;
          this.$vs.notify({
            title: "Update Action",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        });
    },
    statechange(bool) {
      this.bool = !bool;
    },
    test(item) {
      // console.log(item)
    },
  },
  mounted() {
    // if(this.$moment(calldata[0].date).diff(this.$moment(), 'minutes') >= 60) {
    //   this.inactive = true
    // }
    setTimeout(() => {
      this.checker = false;
    }, 900);
    // console.log(this.calldata)
    this.temp = this.calldata[0].temp;
    this.fan = this.calldata[0].fan;
    this.airmode = this.calldata[0].mode;
    this.power = this.calldata[0].power;
    this.temp2 = parseInt(this.calldata[0].temp);
    this.fan2 = this.calldata[0].fan;
    this.airmode2 = this.calldata[0].mode;
    this.power2 = this.calldata[0].power;
    if (this.calldata[0].power == "Off") {
      this.switch1 = false;
      this.bool = false;
    } else {
      this.bool = true;
    }
  },
};
</script>
<style scoped>
.vs-button:visited {
  background-color: yellow;
}
</style>

